import React from 'react';
import { InteractionInfo } from '$/components/Interactions/InteractionInfo';
import { createWithPartialContext } from '$/hooks/withPartialContexts';
import { Transition, MotionValue, useMotionValue } from 'framer-motion';

export type ScrollToCardFn = (
  interaction: InteractionInfo,
  userInitiated: boolean,
  transition?: Transition,
  skipTransition?: boolean,
  skipMarkInteractionInactive?: boolean
) => void;

export type InteractionsStreamContextState = {
  scrollToCard: ScrollToCardFn;
  removingInteraction?: InteractionInfo;
  removingInteractionHeight: MotionValue<number>;
  setRemovingInteraction: React.Dispatch<React.SetStateAction<InteractionInfo | undefined>>;
};

export const InteractionsStreamContext = React.createContext<InteractionsStreamContextState>(
  {} as unknown as InteractionsStreamContextState
);

export const InteractionsStreamContextProvider: React.FC<
  Pick<InteractionsStreamContextState, 'scrollToCard'> & { children: React.ReactNode }
> = React.memo((props) => {
  const removingInteractionHeight = useMotionValue<number>(0);
  const [removingInteraction, setRemovingInteraction] = React.useState<
    InteractionInfo | undefined
  >();
  return (
    <InteractionsStreamContext.Provider
      value={{
        scrollToCard: props.scrollToCard,
        removingInteractionHeight,
        removingInteraction,
        setRemovingInteraction,
      }}
    >
      {props.children}
    </InteractionsStreamContext.Provider>
  );
});

export const withInteractionsStreamContext = createWithPartialContext(InteractionsStreamContext);
